import ky from 'ky';

export const wait = (ms = 1000) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

/*
 * taskFn: A async function that throws an error when a retry has to be made.
 * interval: The max wait time in milliseconds between each retry.
 * retries: The max retries that need to be made before failing. Must be greater than zero.
 */
export const poll = async (taskFn, interval = 5000, retries = 1) => {
  let retriesRemaining = retries;
  do {
    try {
      return await taskFn();
    } catch (err) {
      // If an http error like ( 200 or 500) we assume that the server is not available and break out.
      if (err instanceof ky.HTTPError) {
        throw new Error('Something went wrong');
      }
      retriesRemaining = retriesRemaining - 1;
      await wait(interval);
    }
  } while (retriesRemaining >= 0);
  //If all the retries failed throw an error.
  throw new Error('Max retries reached');
};
